import React, { useState } from 'react';
import './App.css';
import { Link } from 'react-router-dom';
import { supabase } from './supabase';

const sessionTypes = [
  {
    key: 'spiritual',
    title: 'Spiritual Guidance Session',
    desc: '1-on-1 intuitive guidance for clarity, healing, and growth.'
  },
  {
    key: 'energy',
    title: 'Energy Healing Session',
    desc: 'Remote or in-person energy balancing and chakra alignment.'
  },
  {
    key: 'coaching',
    title: 'Intuitive Coaching',
    desc: 'Personalized coaching to help you manifest your goals.'
  },
];

const timeZones = [
  'UTC', 'America/New_York', 'Europe/London', 'Asia/Dubai', 'Asia/Kolkata', 'Australia/Sydney'
];

// Helper to check if mobile view
const isMobile = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 480px)').matches;

function Consultations() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    session: sessionTypes[0].key,
    date: '',
    time: '',
    timezone: 'UTC',
    questions: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    
    try {
      const consultationData = {
        name: form.name,
        email: form.email,
        session_type: form.session,
        session_date: form.date,
        session_time: form.time,
        timezone: form.timezone,
        questions: form.questions || null,
        status: 'pending'
      };
      
      const { error } = await supabase
        .from('consultations')
        .insert([consultationData]);
      
      if (error) throw error;
      
      setTimeout(() => setSubmitted(false), 3000);
    } catch (error) {
      console.error('Error saving consultation:', error);
      setTimeout(() => setSubmitted(false), 3000);
    }
  };

  return (
    <div className="main-bg">
      {/* Hide hero-section on mobile */}
      {!isMobile && (
        <header className="hero-section">
          <h1 className="site-title">Consultations</h1>
          <p className="site-tagline">Book a session, complete your intake form, and pay securely online.</p>
        </header>
      )}
      <div className="consult-section">
        <div className="consult-types">
          <h2>Types of Sessions Offered</h2>
          <div className="consult-type-list">
            {sessionTypes.map(s => (
              <div className="consult-type-card" key={s.key}>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="consult-booking">
          <h2>Book Your Session</h2>
          <form className="consult-form" onSubmit={handleSubmit}>
            <input name="name" type="text" placeholder="Your Name" value={form.name} onChange={handleChange} required />
            <input name="email" type="email" placeholder="Your Email" value={form.email} onChange={handleChange} required />
            <label className="consult-label">Session Type
              <select name="session" value={form.session} onChange={handleChange} required>
                {sessionTypes.map(s => <option value={s.key} key={s.key}>{s.title}</option>)}
              </select>
            </label>
            <label className="consult-label">Date
              <input name="date" type="date" value={form.date} onChange={handleChange} required />
            </label>
            <label className="consult-label">Time
              <input name="time" type="time" value={form.time} onChange={handleChange} required />
            </label>
            <label className="consult-label">Time Zone
              <select name="timezone" value={form.timezone} onChange={handleChange} required>
                {timeZones.map(tz => <option value={tz} key={tz}>{tz}</option>)}
              </select>
            </label>
            <textarea name="questions" placeholder="Any questions or topics for your session?" value={form.questions} onChange={handleChange} rows={3} required />
            <button type="submit" className="consult-btn" disabled={submitted}>{submitted ? 'Processing...' : 'Book'}</button>
            {submitted && <div className="custom-success">We will contact you shortly.</div>}
          </form>
        </div>
      </div>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Life Force Dynamics. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Consultations; 